import { useAccountUsersQuery } from 'hooks/useAccountUsersQuery';
import type { Option } from './types';

export function useSender() {
  const { data, isLoading } = useAccountUsersQuery();
  return {
    options: (data ?? []).map((user) => {
      const option: Option = {
        label: user.fullName,
        value: user.id,
      };

      return option;
    }),
    isLoading,
  };
}
